import * as React from 'react';
import httpService from '../../service/httpService';
import { SystemNavToggle } from './SystemNavToggle';

class SystemHeader extends React.PureComponent{
    
    constructor(props: any) {
        super(props)
    }

    GetUserInfo = async () => {
        //var userName = authProvider.account.userName;
        //var name = authProvider.account.name;
        //var data = await MapAndGetUser(userName, name, 'GuestUser')

        //if (data) {
        //    let status = getUserStatus();
        //    this.setState({ userstatus: status })
        //    this.props.SetSuperAdmin(this.state.SuperAdminMode);
        //    this.props.setUserInformation(data);
        //    return data;
        httpService.get("");
        //}
    }


    render() {

        return (
            <div className="sticky d-none">
                <div className="navbar navbar-expand d-flex justify-content-between bd-navbar white b-b pr-0">
                    <div className="relative">
                        <div className="d-flex">
                            <SystemNavToggle />
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
export default SystemHeader